import axiosInstance from "axios";
import MockAdapter from "axios-mock-adapter";
const { config } = require("../config") as { config: { api: { BASE_URL: string; AUTH_BASE_URL: string } } };

// if (process.env.NODE_ENV == "test") {
//     axiosInstance.interceptors.request.use(request => {
//         console.log('Starting Request', request)
//         return request
//     })
// }

const mockAxios = {
    get: function() {
        return Promise.resolve({ data: {
            subject: {
                user: "subject_user",
                slug: "subject_slug",
                users: []
            }
        }
    })
    },
    post: function() {
        return Promise.resolve({ data: {} })
    }
};

export function mock() {
    return new MockAdapter(axiosInstance);
}

export function authAxios() {
    const user = localStorage.getItem("user");
    const headers = user ? { Authorization: "Bearer " + user } : {};

    if (process.env.NODE_ENV == "test") {
        return axiosInstance;
    }

    return axiosInstance.create({
        baseURL: config.api.AUTH_BASE_URL,
        headers,
    });
}

export function axios() {
    const user = localStorage.getItem("user");

    var headers = {};

    if (user) {
        headers = { Authorization: "Bearer " + user };
    }

    console.log(axiosInstance);

    // Mock Axios object if testing;
    if (process.env.NODE_ENV == "test") {
        return axiosInstance
    }


    return axiosInstance.create({
        baseURL: config.api.BASE_URL,
        headers: headers
    });
}



// const axiosInstance = require("axios");

// var { config } = require("./config");
// var MockAdapter = require("axios-mock-adapter");

// // if (process.env.NODE_ENV == "test") {
// //     axiosInstance.interceptors.request.use(request => {
// //         console.log('Starting Request', request)
// //         return request
// //     })
// // }

// const mockAxios = {
//     get: function() {
//         return Promise.resolve({ data: {
//             subject: {
//                 user: "subject_user",
//                 slug: "subject_slug",
//                 users: []
//             }
//         }
//     })
//     },
//     post: function() {
//         return Promise.resolve({ data: {} })
//     }
// };

// export function mock() {
//     return new MockAdapter(axiosInstance);
// }

// export function axios() {
//     const user: any = localStorage.getItem("user");

//     var headers = {};

//     if (user) {
//         headers = { Authorization: "Bearer " + user };
//     }

//     // Mock Axios object if testing;
//     if (process.env.NODE_ENV == "test") {
//         return axiosInstance
//     }

//     console.log(`Axios configured with BASE_URL: ${config.api.BASE_URL}`);
//     console.log(`Axios configured with browserBaseURL: ${config.api.BASE_URL}`);

//     return axiosInstance.create({
//         baseURL: config.api.BASE_URL,
//         browserBaseURL: config.api.BASE_URL,
//         headers: headers
//     });
// }
// // const axiosInstance = require("axios");

// // var { config } = require("./config");
// // var MockAdapter = require("axios-mock-adapter");

// // // if (process.env.NODE_ENV == "test") {
// // //     axiosInstance.interceptors.request.use(request => {
// // //         console.log('Starting Request', request)
// // //         return request
// // //     })
// // // }

// // const mockAxios = {
// //   get: function () {
// //     return Promise.resolve({
// //       data: {
// //         subject: {
// //           user: "subject_user",
// //           slug: "subject_slug",
// //           users: [],
// //         },
// //       },
// //     });
// //   },
// //   post: function () {
// //     return Promise.resolve({ data: {} });
// //   },
// // };

// // export function mock() {
// //   return new MockAdapter(axiosInstance);
// // }

// // export function axios() {
// //   const user: any = localStorage.getItem("user");

// //   var headers = {};

// //   if (user) {
// //     headers = { Authorization: "Bearer " + user };
// //   }

// //   // Mock Axios object if testing;
// //   if (process.env.NODE_ENV == "test") {
// //     return axiosInstance;
// //   }

// //   console.log(`Axios configured with BASE_URL: ${config.api.BASE_URL}`);
// //   console.log(`Axios configured with browserBaseURL: ${config.api.BASE_URL}`);

// //   return axiosInstance.create({
// //     baseURL: config.api.BASE_URL,
// //     browserBaseURL: config.api.BASE_URL,
// //     headers: headers,
// //   });
// // }
